import { timeRange } from "./filtersTimeFormat";

export const FORM_MAP = {
  RANGE_TIME: 'rangeTime',
  RANGE_TIME_DIFF: 'diff',
  RANGE_TIME_TYPE: 'timeType',
  REGION: 'region',
  SYSTEM: 'system',
  NETWORK_TYPE: 'networkType',
  MEDIA_CHANNEL: 'mediaChannel',
  IS_INIT: 'isInit'
};
export const TIME_TAB: any = [{ tabName: 'Day' }, { tabName: 'Week' }, { tabName: 'Month' }];
export const TAB_NAME: any = {
  Day: 'daily',
  Week: 'weekly',
  Month: 'monthly'
};
export const PUBLIC_STATE = (isPUBGM)=> {
  return {
    [FORM_MAP.RANGE_TIME_TYPE]: 'Day',
    [FORM_MAP.RANGE_TIME]: timeRange(isPUBGM)?.Day,
    [FORM_MAP.RANGE_TIME_DIFF]: false,
    [FORM_MAP.REGION]: {
      regions: [],
      markets: ['255'],
      region_type: 'market'
    },
    [FORM_MAP.SYSTEM]: ['255'],
    [FORM_MAP.NETWORK_TYPE]: ['255'],
    [FORM_MAP.LANGUAGE]: ['255'],
    [FORM_MAP.MEDIA_CHANNEL]: ['255']
  }; 
};
export const PAGE_ID = 'retention';

// UA指标卡片解释弹窗
export const SPEND_METRICS_NAMES = ['Install', 'Register', 'D2(T-1)_D', 'Spend', 'CPI', 'ROAS'];
// UA无spend指标卡片解释弹窗
export const NO_SPEND_METRICS_NAMES = ['Install', 'Register', 'D2(T-1)_D', 'D3(T-2)', 'D7(T-6)'];
// UA指标卡片保留整数的数组
export const INT_LIST = ['Install', 'Register'];

export const METRICS_COLORS = ['#5086F3', '#77E097', '#6A7597', '#F8CC6A', '#A08FF2', '#5EC8F1', '#CF61AC', '#F19E55', '#387F7D', '#F17C86', '#8EB9FF'];
/**
 * RetentionTable组件 tag属性的值.
 */
export const TABLE_TAG = {
  NEW: 'new',
  ACTIVE: 'active',
};

export const TAB_ID_NEW_USERS = 'new';
export const TAB_ID_ACTIVE_USERS = 'active';
export const TAB_ID_RETENTION_USERS = 'retention';
export const TAB_ID_RETURN_USERS = 'return';

// tab切换
export const TABS = [
  { id: TAB_ID_NEW_USERS, label: 'New Users', pageId: '130001', pageName: 'retentionIndexNewUsers', pagePath: '/retention/index/new' },
  { id: TAB_ID_ACTIVE_USERS, label: 'Active Users', pageId: '130002', pageName: 'retentionIndexActiveUsers', pagePath: '/retention/index/active' },
  // { id: TAB_ID_RETENTION_USERS, label: 'Retention Users', pageId: '130003', pageName: 'retentionIndexRetentionUsers', pagePath: '/retention/index/retention' },
  // { id: TAB_ID_RETURN_USERS, label: 'Return Users', pageId: '130004', pageName: 'retentionIndexReturnUsers', pagePath: '/retention/index/return' },
];

/**
 * separated分组标识
 */
export const GROUPS = {
  separated: 'Separated',
};

/**
 * Accumulated筛选器默认值
 */
export const ACCUMLATED_DEFAULT_VALUE = 'accumulated';

/**
 * Accumulated选项组配置
 */
export const ACCUMULATED_OPTIONS = [
  {
    value: ACCUMLATED_DEFAULT_VALUE,
    text: 'Accumulated',
  },
];

/**
 * Separated选项组配置
 */
export const SEPARATED_OPTIONS = [
  {
    groupKey: 'separated',
    value: 'zone',
    text: 'by Zone',
  },
  {
    groupKey: 'separated',
    value: 'region',
    text: 'by Region',
  },
  {
    groupKey: 'separated',
    value: 'country',
    text: 'by Country',
  },
  {
    groupKey: 'separated',
    value: 'system',
    text: 'by System',
  },
  {
    groupKey: 'separated',
    value: 'channel',
    text: 'by Channel ',
  },
];

/**
 * Key Days 默认值
 */
export const KEY_DAYS_DEFAULT_VALUE = 0;

/**
 * Key Days 筛选器选项组
 */
export const KEY_DAYS_OPTIONS = [
  {
    value: 0,
    text: 'Key Days',
    tooltip: '',
  },
  {
    value: 30,
    text: '1 ~ 30 Days',
    tooltip: '',
  },
  {
    value: 60,
    text: '1 ~ 60 Days',
  },
  {
    value: 90,
    text: '1 ~ 90 Days',
  },
  {
    value: 180,
    text: '1 ~ 180 Days',
  },
];

export const LINE_CHART_TITLE = {
  new: 'New',
  active: 'Active',
};

export const QUERY_PERIOD = {
  Day: 'daily',
  Week: 'weekly',
  Month: 'monthly',
};

export const PUBLIC_HEIGHT = 350;
export const DWM = {
  Day: 'DAU',
  Week: 'WAU',
  Month: 'MAU',
};

export const SEGMENT_LIST = [
  { text: "Country", value: "country" },
  { text: "Region", value: "region" },
  { text: "Zone", value: "zone" },
];

export const SEGMENT_JSON = {
  country: "Country",
  region: "Region",
  zone: 'Zone'
};
export const SEGMENT_TITLE_JSON = {
  country: "Countries",
  region: "Regions",
  zone: 'Zones'
};

export const HEAT_TABLE_COLUMNS_DEFAULT = [
  {
    key: "1d_ltv",
    title: "1D LTV",
    width: 200
  },
  {
    key: "2d_ltv",
    title: "2D LTV",
    width: 200
  },
  {
    key: "3d_ltv",
    title: "3D LTV",
    width: 200
  },
  {
    key: "7d_ltv",
    title: "7D LTV",
    width: 200
  },
  {
    key: "14d_ltv",
    title: "14D LTV",
    width: 200
  },
  {
    key: "30d_ltv",
    title: "30D LTV",
    width: 200
  },
  {
    key: "60d_ltv",
    title: "60D LTV",
    width: 200
  },
  {
    key: "90d_ltv",
    title: "90D LTV",
    width: 200
  },
  {
    key: "180d_ltv",
    title: "180D LTV",
    width: 200
  },
];

export const INIT_COUNTRY_REGION_DATA = { tableData: [], chartData: [] };

export const COUNTRY_REGION_TYPE = [
  { text: 'Country', value: 'country' },
  { text: 'Region', value: 'region' },
  { text: 'Network Type', value: 'network_type' }
];


export const BREAK_DOWN_CONFIG = {
  register: {
    isHaveBar: true,
    isHaveLine: true,
    isHavePie: true,
    isHaveShare: true,
  },
  cpa: {
    isHaveBar: true,
    isHaveLine: true,
    isHavePie: false,
    isHaveShare: false,
  },
  ltv: {
    isHaveBar: true,
    isHaveLine: true,
    isHavePie: false,
    isHaveShare: false,
  },

};

export const METRICS_INFO: any = {
  // UA
  Install: {
    title: 'Install',
    font: '',
    end: '',
    type: 'int',
  },
  Register: {
    title: 'Register',
    font: '',
    end: '',
    type: 'int',
  },
  'D2(T-1)': {
    title: 'D2(T-1)',
    font: 'Avg.',
    end: '',
    type: 'percent',
  },
  'D3(T-2)': {
    title: 'D3(T-2)',
    font: 'Avg.',
    end: '',
    type: 'percent',
  },
  'D7(T-6)': {
    title: 'D7(T-6)',
    font: 'Avg.',
    end: '',
    type: 'percent',
  },
  Spend: {
    title: 'Spend',
    font: '',
    end: '($)',
    type: 'int',
  },
  CPI: {
    title: 'CPI',
    font: 'Avg.',
    end: '($)',
    type: 'int',
  },
  ROAS: {
    title: 'ROAS',
    font: 'Avg.',
    end: '',
    type: 'bigPercent',
  },

  // Overview
  Revenue: {
    title: 'Revenue',
    font: '',
    end: '($)',
    type: 'int',
    decimal: 2,
  },
  New: {
    title: 'New',
    font: '',
    end: '',
    type: 'int'
  },
  ARPU: {
    title: 'ARPU',
    font: '',
    end: '($)',
    type: 'int',
    decimal: 2,
  },
  'PayerRatio%': {
    title: 'Payer%',
    font: '',
    end: '%',
    type: 'int'
  },
  'Payer%': {
    title: 'Payer%',
    font: '',
    end: '',
    type: 'percent',
    decimal: 2,
  },
  DAU: {
    title: 'DAU',
    font: 'Avg.',
    end: '',
    type: 'int'
  },
  WAU: {
    title: 'WAU',
    font: 'Avg.',
    end: '',
    type: 'int'
  },
  'W2(T-1)': {
    title: 'W2(T-1)',
    font: '',
    end: '',
    type: 'percent',
    decimal: 2,
  },
  MAU: {
    title: 'MAU',
    font: 'Avg.',
    end: '',
    type: 'int'
  },
  'M2(T-1)': {
    title: 'M2(T-1)',
    font: '',
    end: '',
    type: 'percent',
    decimal: 2,
  },
};

export const titltText: any = {
  'Install': 'ua_Install',
  'Register': 'ua_Register',
  'Spend($)': 'ua_spend',
  'Spend': 'ua_spend',
  'D2(T-1)': 'ua_d2t1',
  'D2(T-1)_D': 'ua_d2t1',
  'D3(T-2)': 'ua_no_spend_d3',
  'D7(T-6)': 'ua_no_spend_d7',
  'CPI($)': 'ua_cpi',
  'CPI': 'ua_cpi',
  'ROAS': 'ua_ROAS',
  'Avg.D2(T-1)': 'ua_avgd2',
  'Avg.CPI($)': 'ua_avgcpi',
  'Avg.ROAS': 'ua_avgroas',
  'Avg.D3(T-2)': 'ua_no_spend_avgd3',
  'Avg.D7(T-6)': 'ua_no_spend_avgd7',
};

export const explainMap: any = {
  'Install': 'Install',
  'Register': 'Register',
  'Spend($)': 'Spend($)',
  'Spend': 'Spend($)',
  'D2(T-1)': 'D2(T-1)',
  'D2(T-1)_D': 'D2(T-1)',
  'D3(T-2)': 'D3(T-2)',
  'D7(T-6)': 'D7(T-6)',
  'CPI($)': 'CPI($)',
  'CPI': 'CPI($)',
  'ROAS': 'ROAS',
  'Avg.D2(T-1)': 'Avg.D2(T-1)',
  'Avg.CPI($)': 'Avg.CPI($)',
  'Avg.ROAS': 'Avg.ROAS',
  'Avg.D3(T-2)': 'Avg.D3(T-2)',
  'Avg.D7(T-6)': 'Avg.D7(T-6)',
};